import React from 'react';
import { Role } from '../../consts';
import { Site } from '../../lib/Site';
import AgencyLabel from '../AgencyLabel/AgencyLabel';
import TopLevelNavigationDetachedDropdownItem from '../TopLevelNav/TopLevelNavigationDetachedDropdownItem';
import TopLevelNavigationDropdownItem from '../TopLevelNav/TopLevelNavigationDropdownItem';
import TopLevelNavigationItem from '../TopLevelNav/TopLevelNavigationItem';
import CommunityMenu from './CommunityMenu';
import YourWorkMenu from './YourWorkMenu';

interface Props {
    role: Role;
    focused: boolean;
    site: Site;
    isStaticTemplate?: boolean;
    isBlog?: boolean;
}

export default function PrimaryNavigation({
    role,
    focused,
    site,
    isStaticTemplate = false,
    isBlog = false,
}: Props) {
    if (focused) return null;
    const languageCode = site.getLanguageCode();
    return (
        <div className="site-header__item site-header__item--primary-navigation">
            <div className="top-level-nav">
                {isBlog && (
                    <React.Fragment>
                        <TopLevelNavigationItem label={__('Get a design')} url="/categories" />
                        <TopLevelNavigationItem label={__('How it works')} url="/how-it-works" />
                        <TopLevelNavigationItem
                            label={__('Find a designer')}
                            url="/designers/search"
                        />
                        <TopLevelNavigationItem label={__('Inspiration')} url="/discover" />
                        {languageCode === 'en' || languageCode === 'de' ? (
                            <TopLevelNavigationItem label={__('Studio')} url="/pro/studio" />
                        ) : (
                            <TopLevelNavigationItem label="Pro" url="/pro" />
                        )}
                    </React.Fragment>
                )}
                {role === 'designer' && !isBlog && (
                    <React.Fragment>
                        {isStaticTemplate && (
                            <React.Fragment>
                                <TopLevelNavigationDetachedDropdownItem
                                    label={__('Your work')}
                                    additionalClasses={['top-level-nav__item--first']}
                                    url="/work"
                                >
                                    <YourWorkMenu />
                                </TopLevelNavigationDetachedDropdownItem>
                                <TopLevelNavigationItem
                                    label={__('Your clients')}
                                    url="/your-clients"
                                />
                                <TopLevelNavigationDetachedDropdownItem
                                    label={__('Community')}
                                    url="/community"
                                >
                                    <CommunityMenu />
                                </TopLevelNavigationDetachedDropdownItem>
                            </React.Fragment>
                        )}
                        {!isStaticTemplate && (
                            <React.Fragment>
                                <TopLevelNavigationDropdownItem
                                    label={__('Your work')}
                                    additionalClasses={['top-level-nav__item--first']}
                                    url="/work"
                                >
                                    <YourWorkMenu />
                                </TopLevelNavigationDropdownItem>
                                <TopLevelNavigationItem
                                    label={__('Your clients')}
                                    url="/your-clients"
                                />
                                <TopLevelNavigationDropdownItem
                                    label={__('Community')}
                                    url="/community"
                                >
                                    <CommunityMenu />
                                </TopLevelNavigationDropdownItem>
                            </React.Fragment>
                        )}
                    </React.Fragment>
                )}
                {role === 'contest-holder' && !isBlog && (
                    <React.Fragment>
                        <TopLevelNavigationItem
                            label={__('Your work')}
                            url="/work"
                            additionalClasses={['top-level-nav__item--first']}
                        />
                        <TopLevelNavigationItem label={__('Designers')} url="/designers/contacts" />
                        <TopLevelNavigationItem label={__('Categories')} url="/categories" />
                        <TopLevelNavigationItem label={__('Inspiration')} url="/discover" />
                    </React.Fragment>
                )}
                {role === 'logged-out' && !isBlog && (
                    <React.Fragment>
                        <TopLevelNavigationItem label={__('Categories')} url="/categories" />
                        <TopLevelNavigationItem label={__('How it works')} url="/how-it-works" />
                        <TopLevelNavigationItem
                            label={__('Find a designer')}
                            url="/designers/search"
                        />
                        <TopLevelNavigationItem label={__('Inspiration')} url="/discover" />
                        {languageCode === 'en' || languageCode === 'de' ? (
                            <TopLevelNavigationItem label={__('Studio')} url="/pro/studio" />
                        ) : (
                            <TopLevelNavigationItem label="Pro" url="/pro" />
                        )}
                    </React.Fragment>
                )}
            </div>
        </div>
    );
}
